/*eslint-disable no-undef */
/*eslint-disable no-console */
import phina from 'phina.js'
import April from '../ALizard/April'

export default ()=>{
/**
 * BattleScene
 */
phina.define('BattleScene', {
  superClass : "MyDisplayScene",
  init : function(param) {
      var self = this;
      this.superInit({width:1000,height:600,scale:param.scale});
      this.bg=phina.display.Sprite("img/ui/bg2.png")
      .setPosition(500,300).setSize(1000,600).addChildTo(this);
      this.bg2=phina.display.Sprite(param.bg)
      .setPosition(500,300).setSize(1000,400).addChildTo(this);
    // 初期化
      this.scrollable=phina.accessory.Scrollable2(this, true)
      .attachTo(this);
      this.scrollable.horizontal = false;
      this
      .on('scrollstart', function(){
      })
      .on('scrollup', function(){
        console.log('scrollup')
        self.player
        .stop().back();
        if(self.scrollmap){
            self.scrollmap.value=self.player.cur;
        }else{
            self.scrollmap=BattleScene.ScrollMap({
              width:40, height:500,
              fill:'rgba(128,128,128,64)', stroke:'transparent',
              length:self.player.length, value:self.player.cur,
              scaleAry:self.player.split,
            }).addChildTo(this).setPosition(500,300)
            .on('removed', function(){ self.scrollmap = null; });
        }
      })
      .on('scrolldown', function(){
        console.log('scrolldown')
        self.player
        .stop().next();
        if(self.scrollmap){
            self.scrollmap.value=self.player.cur;
        }else{
            self.scrollmap=BattleScene.ScrollMap({
              width:40, height:500,
              fill:'rgba(128,128,128,64)', stroke:'transparent',
              length:self.player.length, value:self.player.cur,
              scaleAry:self.player.split,
            }).addChildTo(this).setPosition(500,300)
            .on('removed', function(){ self.scrollmap = null; });
        }
      })
      .on('scrollend', function(){
        if(self.scrollmap){ //TODO 並列イベント対策
        }
        self.scrollmap=null;
      });
      // self.mousewheelscroll = phina.accessory.MouseWheelScrollable()
      // .attachTo(this)
      // .on('scroll', function(e){
      //   console.log('wheelscroll')
      //   if(e.dy > 0){
      //     self.player
      //     .stop().back();
      //   }else{
      //     self.player
      //     .stop().next();
      //   }
      //   if(self.scrollmap){
      //       self.scrollmap.value=self.player.cur;
      //   }else{
      //       self.scrollmap=BattleScene.ScrollMap({
      //         width:40, height:500,
      //         fill:'rgba(128,128,128,64)', stroke:'transparent',
      //         length:self.player.length, value:self.player.cur,
      //         scaleAry:self.player.split,
      //       }).addChildTo(self).setPosition(500,300)
      //       .on('removed', function(){ self.scrollmap = null; });
      //   }
      // })
      // self.mousewheelscroll.horizontal = false;

      this.field = BattleScene.HorizontalField({
        player:param.player, enemy:param.enemy,
        playerTeam:param.playerTeam, enemyTeam:param.enemyTeam,
        animation:true,
      }).addChildTo(this).setPosition(500,300);

      this.controlArea = phina.display.RectangleShape({
        width:400, height:50,
        fill:'#000', stroke:'transparent',
      }).addChildTo(this).setPosition(200,570).fromJSON({alpha:0.7});
      // this.backButton = NormalButton({
      //   width:150, height:40,
      //   text:'戻る', fontSize:20,
      // }).addChildTo(this).setPosition(100,570)
      // .on('click', this.goMainScene.bind(this));
      // this.backButton = NormalButton({
      //   width:150, height:40,
      //   text:'再生', fontSize:20,
      // }).addChildTo(this).setPosition(300,570)
      // .on('click', function(){
      //   self.scrollable.cancel();
      //   self.player.start();
      // });

      this.player = BattleScene.Player({
        out:param.out, field:this.field, animation:true,
      });
      this.tweener
        .wait(2000)
        .call(function(){ this.field.flare('battleinit') }.bind(this))
        .wait(this.field.initializeTime)
        .call(function(){
          this.player.start();
        }.bind(this));
    },
    goMainScene: function(){
        this.exit('ResultScene');
    },
    _static:{
      assets:{
        image:{
          "img/ui/at.png":"img/ui/at.png",
          "img/ui/df.png":"img/ui/df.png",
          "img/ui/mt.png":"img/ui/mt.png",
          "img/ui/sd.png":"img/ui/sd.png",
          "img/ui/bufficon5.png":"img/ui/bufficon5.png",
          "img/ui/F_hunou.png":"img/ui/F_hunou.png",
          "img/ui/F_exp.png":"img/ui/F_exp.png",
          "img/ui/critical.png":"img/ui/critical.png",
          "img/ui/dodge.png":"img/ui/dodge.png",
          "img/ui/F_miss.png":"img/ui/F_miss.png",
          "img/ui/font13.png": "img/ui/font13.png",
          "img/ui/bg2.png": "img/ui/bg2.png",
        }
      }
    }
});

phina.define('BattleScene.Player', {
  init: function(param){
    var self = this;
    this._animation = !!param.animation;    // アニメーション中か否か
    this._actionlist = [];            // アクションリスト
    this._cur = 0;                // 現在のアクションインデックス
    this._field = param.field;          // フィールド

    //アクションリストを作成
    // var cur=0;
    param.out.map(function(data, i){
      if(April.call(data.call,{opr:'split',scene: self}.$extend(data.arguments))){
        self._actionlist.push({
          split:true,
        });
      }
      self._actionlist.push({
        no: i, data: data, split:false,
      })
    });
    self._actionlist.shift();

    this._splitary = this._actionlist.map(function(v){
      return v.data?v.data.call=='DisplayComponent/event.next-turn':false;
    });
  },
  play: function(next){
    var self=this;
    var opr = self._animation?'play':next>0?'next':'back';
    if(this._cur==0 && next==-1){ return; } //巻き戻りすぎ対策
    for(var i=this._cur;i>=0&&i<this._actionlist.length;i+=next){
      if(this._actionlist[i].split){
        if(i!=this._cur){
          if(!this._animation){
            this._cur = i+next;
          }
          self._field.tweener
          .call(function(_i){
            console.log(_i, opr, self._actionlist[_i].data);
          },self,[i]);
          break;
        }else{
          continue;
        }
      }else{
        var data = this._actionlist[i].data;
        if(this._animation){ // 先にログを出す
          self._field.tweener
          .call(function(_i){
            console.log(_i, opr, self._actionlist[_i].data);
          },self,[i]);
        }else{
          console.log(i, opr, self._actionlist[i].data);
        }
        April.call(data.call,{
          opr: opr,
          scene: self._field,
          tweener: self._field.tweener,
        }.$extend(data.arguments));
        if(this._animation){
          self._field.tweener
          .call(function(_i){
            this._cur = _i+next;
          },self,[i]);
        }else{
          if(i+next<0||i+next>=this._actionlist.length){
            self._cur=i;
          }
        }
      }
    }
    if(this._animation){
      this._field.tweener
      .call(function(){
        if(self._cur!=self._actionlist.length){
          self.next();
        }else{
          self._cur-=1;
        }
      });
    }
  },
  start: function(){
    this._animation = true;
    this._field.tweener.clear();
    this.play(1);
    return this;
  },
  stop: function(){
    if(this._animation){
      this._animation = false;
      this._field.tweener.clear();
    }
    return this;
  },
  next: function(){
    this.play(1);
    return this;
  },
  back: function(){
    this.play(-1);
    return this;
  },
  first: function(){
    this.stop();
    while(this._cur>0){
      this.back();
    }
    return this;
  },
  _accessor: {
    field: { get: function(){ return this._field; }},
    cur: { get: function(){ return this._cur; }},
    length: { get: function(){ return this._actionlist.length; }},
    split: { get: function(){ return this._splitary; }},
  },
});
phina.define('BattleScene.ScrollMap', {
    superClass:'phina.display.RectangleShape',
    init: function(param){
      param=(param||{}).$safe(BattleScene.ScrollMap.defaultValue);
      this.superInit(param);
      var gridY = phina.util.Grid({
        width:this.height*((param.length-1)/param.length),
        columns:param.length,
        offset:this.height/param.length/2,
      });
      this._value=param.value;
      this
      .setScale(0.0, 0.0)
      .on('added', function(e){
        e.target.tweener.clear()
          .scaleTo(1.0,200,'easeOutCubic');
      })
      .on('remove', function(e){
        e.target.tweener.clear()
          .scaleTo(0.0,200,'easeOutCubic')
          .call(function(){ e.target.remove() });
      })
      .on('changed', function(e){
        var self = this;
        e.target.cursor.tweener
        .clear()
        .moveTo(this.width/2,gridY.span(e.target.value)-e.target.height/2,100,'easeOutElastic')
        .wait(1000)
        .call(function(){ self.flare('remove'); });
      });
      phina.display.PathShape({
        stroke:'#FFF', strokeWidth: 1,
        paths: [Vector2(0,-this.height/2), Vector2(0,this.height/2)],
      }).addChildTo(this);
      for(var i=0;i<=param.length;i++){
        if(param.scaleAry.length==0 || param.scaleAry[i]){
          phina.display.PathShape({
          stroke:'#FFF', strokeWidth: 1,
          paths: [Vector2(-this.width/2+5,0),Vector2(this.width/2-5,0)],
          }).addChildTo(this).setPosition(0,gridY.span(i)-this.height/2);
        }
      }
      this.cursor=phina.display.TriangleShape({
        fill:'#FFF', stroke:'transparent', radius:10,
      }).addChildTo(this).setPosition(this.width/2,gridY.span(this._value)-this.height/2)
      .setRotation(-90.0);
    },
    _accessor: {
      value: { get: function(){ return this._value; },
        set: function(v){ this._value=v; this.flare('changed',{value:v}); }},
    },
    _static: {
      defaultValue: {
        scaleAry: [],
      },
    },
});

phina.define('BattleScene.Field', {
  superClass: 'phina.display.DisplayElement',
  init: function(param){
    param = (param||{}).$safe(BattleScene.Field.defaults);
    this.superInit(param);
    this.fromJSON({ _member:{}, _initializeTime:0 });
  },
  addMember: function(unit){
    this._member[unit.ID] = unit;
  },
  removeMember: function(unit){
    delete this._member[unit.ID];
  },
  _static: {
    defaults:{
      animation: false,
    }
  },
  _accessor:{
    member: { get: function(){ return this._member; }},
    initializeTime: { get: function(){ return this._initializeTime } }
  },
});
phina.define('BattleScene.HorizontalField', {
  superClass: 'BattleScene.Field',
  init: function(param){
    var self=this;
    this.superInit({ width:1000, height:600 });
    this.playerTeam=self.buildTeam(
      param.player, param.playerTeam, 1, param.animation
    ).on('addMember',function(e){ self.addMember(e.value) })
    .on('removeMember',function(e){ self.removeMember(e.value) })
    .addChildTo(this).setPosition(-275,-30)
    this.enemyTeam=self.buildTeam(
      param.enemy, param.enemyTeam, -1, param.animation
    ).on('addMember',function(e){ self.addMember(e.value) })
    .on('removeMember',function(e){ self.removeMember(e.value) })
    .addChildTo(this).setPosition(275,20)

    this._initializeTime = Math.max(this.playerTeam.initializeTime, this.enemyTeam.initializeTime);
    this.on('battleinit', function(){
      this.playerTeam.flare('battleinit');
      this.enemyTeam.flare('battleinit');
    });
  },
  buildTeam: function(data, team, reverse, animation){
    if(team=='5Unit'){
      return BattleScene.FiveUnitTeam(data, reverse, animation);
    }else if(team=='12Unit'){
      return BattleScene.TwelveUnitTeam(data, reverse, animation);
    }else if(team=='5Unit2'){
      return BattleScene.FiveUnitTeam2(data, reverse, animation);
    }else{
      return BattleScene.FiveUnitTeam(data, reverse, animation);
    }
  },
});

phina.define('BattleScene.Team', {
  superClass: 'phina.display.DisplayElement',
  init: function(param){
    this.superInit(param);
    this._reverse = param.reverse;
    this._initializeTime = 0;
  },
  addMember: function(){ //data
  },
  removeMember: function(){ //data
  },
  _accessor: {
    reverse:{
      get: function(){ return this._reverse; }
    },
    initializeTime:{ get: function(){ return this._initializeTime } }
  }
});
phina.define('BattleScene.FiveUnitTeam', {
  superClass: 'BattleScene.Team',
  init: function(param, reverse ,animation){
    var self = this;
    this.superInit({
      width:450, height:525, reverse: reverse,
    });
    this.childcounter = 0;
    param.map(function(data, i){
      self[data.id] = BattleScene.LMCharacter(data, reverse)
      .addChildTo(self)
      .setPosition(-75*reverse,phina.util.Grid({
        width:self.height,columns:5,offset:-self.height/2+100/2+(animation&&600)}).span(i));
      if(animation){
        self[data.id].tweener
          .wait(reverse<0?500:0)
          .wait(i*250)
          .by({x:0,y:-600},500,"easeOutCubic");
      }
      self.on('added',function(){ self.flare('addMember',{value: self[data.id]}); });
    });
  },
  addMember: function(data){
    var self=this;
    this[data.id] = BattleScene.SWCharacter(data, this.reverse)
    .addChildTo(this)
    .setPosition(155*this.reverse, phina.util.Grid({
      width:this.height,columns:7,offset:-this.height/2+35
    }).span(this.childcounter));
    this.childcounter++;
    self.flare('addMember',{value: self[data.id]});
  },
  removeMember: function(data){
    var self=this;
    this[data.id].remove();
    this.childcounter--;
    this.flare('removeMember',{value: self[data.id] });
    delete this[data.id];
  },
});
phina.define('BattleScene.FiveUnitTeam2', {
  superClass: 'BattleScene.Team',
  init: function(param, reverse ,animation){
    var self = this;
    this.superInit({
      width:450, height:525, reverse: reverse,
    });
    this.childcounter = 0;
    param.map(function(data, i){
      self[data.id] = BattleScene.LWCharacter2(data, reverse)
      .addChildTo(self)
      .setPosition(-75*reverse,phina.util.Grid({
        width:self.height,columns:5,offset:-self.height/2+100/2+(animation&&600)}).span(i));
      if(animation){
        self[data.id].tweener
          .wait(reverse<0?500:0)
          .wait(i*250)
          .by({x:0,y:-600},500,"easeOutCubic")
      }
      self.on('added',function(){ self.flare('addMember',{value: self[data.id]}); });
      self._initializeTime = Math.max(self._initializeTime, self[data.id].initializeTime);
      self.on('battleinit',function(){ self[data.id].flare('inited'); })
    });
  },
  addMember: function(data){
    var self=this;
    this[data.id] = BattleScene.SWCharacter(data, this.reverse)
    .addChildTo(this)
    .setPosition(155*this.reverse, phina.util.Grid({
      width:this.height,columns:7,offset:-this.height/2+35
    }).span(this.childcounter));
    this.childcounter++;
    self.flare('addMember',{value: self[data.id]});
  },
  removeMember: function(data){
    var self=this;
    this[data.id].remove();
    this.childcounter--;
    this.flare('removeMember',{value: self[data.id] });
    delete this[data.id];
  },
});
phina.define('BattleScene.TwelveUnitTeam', {
  superClass: 'BattleScene.Team',
  init: function(param, reverse ,animation){
    var self = this;
    this.superInit(param.$extend({
      width:450, height:525, reverse: reverse,
    }));
    this.childcounter = 0;
    param.map((data, i)=>{
      self[data.id] = BattleScene.MWCharacter(data, reverse)
      .addChildTo(self)
      .setPosition(phina.util.Grid({width:400,columns:2,offset:-this.width/4-(animation&&500)}).span(Math.floor(i/6))*reverse,
      phina.util.Grid({width:self.height,columns:6,offset:-self.height/2+40,loop:true}).span(i));
      if(animation){
        self[data.id].tweener
          .wait(reverse<0?500:0)
          .wait(150)
          .by({x:500*reverse,y:0},500,"easeOutCubic");
      }
      self.on('added',function(){ self.flare('addMember',{value: self[data.id]}); });
      this.childcounter++;
    });
  },
  addMember: function(data){
    this[data.id] = BattleScene.MWCharacter(data, this.reverse)
    .addChildTo(this)
    .setPosition(phina.util.Grid({width:this.width,columns:2,offset:-this.width/4}).span(Math.floor(this.childcounter/6))*this.reverse,
    phina.util.Grid({width:this.height,columns:6,offset:-this.height/2+40,loop:true}).span(this.childcounter));
    this.childcounter++;
    this.on('added',()=>{ this.flare('addMember',{value: this[data.id]}); });
  },
  removeMember: function(data){
    this[data.id].remove();
    delete this[data.id];
    this.childcounter--;
  },
});

phina.define('BattleScene.Unit', {
  superClass: 'phina.display.RectangleShape',
  init: function(param){
    this.superInit(param);
  },
  _accessor: {
    ID: { get: function(){ return this._ID; },
      set: function(v){ this._ID=v; }},
  },
});
phina.define('BattleScene.Character', {
  superClass: 'BattleScene.Unit',
  init: function(param, reverse){
    this.superInit(param);
    this.name = param.name;
    this.icon = param.icon||'noimage';
    this.iconR = param.iconR;
    this.HP = param.HP;
    this.MHP = param.MHP;
    this.SP = param.SP;
    this.MSP = param.MSP;
    this.ID = param.id;
    this.unitType = param.stype;
    this.reverse = reverse;
    this._buff = {};
    this.live = true;
    this._initializeTime = 0;
  },
  _static: {
    defaultValue: {
    },
  },
  addBuff: function(data){
    this._buff[data.RID] = data;
  },
  removeBuff: function(data){
    delete this._buff[data.RID];
  },
  _accessor: {
    name: { get: function(){ return this._name; },
      set: function(v){ this._name=v; }},
    HP: { get: function(){ return this._HP; },
      set: function(v){
        v>this._MHP&&(v=this._MHP);
        this._HP!=v&&this.flare('changeHP',{value:v});
        this._HP=v;
      }},
    MHP: { get: function(){ return this._MHP; },
      set: function(v){
        this._MHP!=v&&this.flare('changeMHP',{value:v}); this._MHP=v; }},
    SP: { get: function(){ return this._SP; },
      set: function(v){
        v>this._MSP&&(v=this._MSP);
        this._SP!=v&&this.flare('changeSP',{value:v});
        this._SP=v;
      }},
    MSP: { get: function(){ return this._MSP; },
      set: function(v){
        this._MSP!=v&&this.flare('changeMSP',{value:v}); this._MSP=v; }},
    unitType: { get: function(){ return this._unitType; },
      set: function(v){ this._unitType=v; }},
    icon: { get: function(){ return this._icon; },
      set: function(v){ this._icon=v; }},
    reverse: { get: function(){ return this._reverse; },
      set: function(v){ this._reverse=v; }},
    buff: { get: function(){ return this._buff; }},
    live: { get: function(){ return this._live; },
      set: function(v){ this._live!=v&&this.flare('changeLive',{value:v}); this._live=v; }},
    initializeTime:{ get: function(){ return this._initializeTime; } }
  },
});
phina.define('BattleScene.LWCharacter', {
  superClass: 'BattleScene.Character',
  init: function(param, reverse){
    var self=this;
    this.superInit(param.$extend({
      width:300, height:100,
      fill:'transparent', stroke:'#000',
    }), reverse);

    this
    .on('changeLive',function(e){
      e.value?self.alpha=1.0:self.alpha=0.5;
    });
    this.iconImage = phina.display.Sprite(
        this.icon
    ).setSize(300,75).addChildTo(this).setPosition(0,-12);
    if(this.iconR){
      this.iconImage.setScale(reverse,1);
    }
    this.hpGauge = HPGauge({
      width:300, height:25,
      fill:'rgba(0,0,0,64)', stroke:'#FFF', strokeWidth:2,
      value:this.HP, maxValue:this.MHP,
      gaugeColor:'green',
    }).addChildTo(this
      .on('changeHP',function(e){this.hpGauge.setValue(e.value) }.bind(self))
    ).setPosition(0,38);
    this.spGauge = SPGauge({
      width:100, height:5,
      fill:'#FFF', stroke:'#FFF', strokeWidth:2,
      value:this.SP, maxValue:this.MSP,
      gaugeColor: 'blue',
    }).addChildTo(this
      .on('changeSP',function(e){this.spGauge.setValue(e.value) }.bind(self))
    ).setPosition(-100,22);
    this.nameLabel = phina.display.Label({
      width:300, height:20,
      text:this.name, align:'left',
      fill:'#FFF', fontSize:20,
    }).addChildTo(this).setPosition(-150,40);
    this.statusType = phina.display.Sprite(
      this.unitType=='AT'?'img/ui/at.png':
          this.unitType=='DF'?'img/ui/df.png':
          this.unitType=='MT'?'img/ui/mt.png':
          this.unitType=='SD'?'img/ui/sd.png':'noimage'
    ).addChildTo(this).setPosition(130,5);
    this.buffpocket = BattleScene.BuffPocket({
      width:300,
    }).addChildTo(this).setPosition(0,-35);
  },
  addBuff: function(data){
    this.superMethod('addBuff', data);
    this.buffpocket.addBuff(data);
  },
  removeBuff: function(data){
    this.superMethod('removeBuff', data);
    this.buffpocket.removeBuff(data);
  },
});
phina.define('BattleScene.LWCharacter2', {
  superClass: 'BattleScene.Character',
  init: function(param, reverse){
    var self=this;
    this.superInit(param.$extend({
      width:300, height:100,
      fill:'transparent', stroke:'#000',
    }), reverse);

    this
    .on('changeLive',function(e){
      e.value?self.alpha=1.0:self.alpha=0.5;
    })
    .on('inited', function(){
      this.hpGauge.setValue(this.HP);
    });
    this.iconImage = phina.display.Sprite(
        this.icon
    ).setSize(300,75).addChildTo(this).setPosition(0,-12);
    if(this.iconR){
      this.iconImage.setScale(reverse,1);
    }
    this.hpGauge = HPGauge2({
      width:300, height:25,
      fill:'rgba(0,0,0,64)', stroke:'#FFF', strokeWidth:2,
      value:0, maxValue:this.MHP,
      gaugeColor:['green', '#0C0'],
    }).addChildTo(this
      .on('changeHP',function(e){this.hpGauge.setValue(e.value) }.bind(self))
    ).setPosition(0,38);
    this._initializeTime = 2250;
    this.spGauge = SPGauge({
      width:100, height:5,
      fill:'#FFF', stroke:'#FFF', strokeWidth:2,
      value:this.SP, maxValue:this.MSP,
      gaugeColor: 'blue',
    }).addChildTo(this
      .on('changeSP',function(e){this.spGauge.setValue(e.value) }.bind(self))
    ).setPosition(-100,22);
    this.nameLabel = phina.display.Label({
      width:300, height:20,
      text:this.name, align:'left',
      fill:'#FFF', fontSize:20,
    }).addChildTo(this).setPosition(-150,40);
    this.statusType = phina.display.Sprite(
      this.unitType=='AT'?'img/ui/at.png':
          this.unitType=='DF'?'img/ui/df.png':
          this.unitType=='MT'?'img/ui/mt.png':
          this.unitType=='SD'?'img/ui/sd.png':'noimage'
    ).addChildTo(this).setPosition(130,5);
    this.buffpocket = BattleScene.BuffPocket({
      width:300,
    }).addChildTo(this).setPosition(0,-35);
  },
  addBuff: function(data){
    this.superMethod('addBuff', data);
    this.buffpocket.addBuff(data);
  },
  removeBuff: function(data){
    this.superMethod('removeBuff', data);
    this.buffpocket.removeBuff(data);
  },
});
phina.define('BattleScene.MWCharacter', {
  superClass: 'BattleScene.Character',
  init: function(param, reverse){
    var self=this;
    this.superInit(param.$extend({
      width:200, height:80,
      fill:'transparent', stroke:'#000',
    }), reverse);

    this
    .on('changeLive',function(e){
      e.value?self.alpha=1.0:self.alpha=0.5;
    });
    this.iconImage = phina.display.Sprite(
        this.icon
    ).setSize(200,50).addChildTo(this).setPosition(0,-15);
    this.hpGauge = HPGauge({
      width:200, height:30,
      fill:'rgba(0,0,0,64)', stroke:'#FFF', strokeWidth:2,
      value:this.HP, maxValue:this.MHP,
      gaugeColor:'green',
    }).addChildTo(this
      .on('changeHP',function(e){this.hpGauge.setValue(e.value) }.bind(self))
    ).setPosition(0,25);
    this.spGauge = phina.ui.Gauge({
      width:100, height:5,
      fill:'#FFF', stroke:'#FFF', strokeWidth:2,
      value:this.SP, maxValue:this.MSP,
      gaugeColor: 'blue',
    }).addChildTo(this
      .on('changeSP',function(e){this.spGauge.setValue(e.value) }.bind(self))
    ).setPosition(-50,5);
    this.nameLabel = phina.display.Label({
      width:200, height:20,
      text:this.name, align:'left',
      fill:'#FFF', fontSize:20,
    }).addChildTo(this).setPosition(-100,25);
    this.statusType = phina.display.Sprite(
        this.unitType=='AT'?'img/ui/at.png':
        this.unitType=='DF'?'img/ui/df.png':
        this.unitType=='MT'?'img/ui/mt.png':
        this.unitType=='SD'?'img/ui/sd.png':'noimage'
    ).addChildTo(this).setPosition(80,-10);
    this.buffpocket = BattleScene.BuffPocket({
      width:200,
    }).addChildTo(this).setPosition(0,-25);
  },
  addBuff: function(data){
    this.superMethod('addBuff', data);
    this.buffpocket.addBuff(data);
  },
  removeBuff: function(data){
    this.superMethod('removeBuff', data);
    this.buffpocket.removeBuff(data);
  },
});
phina.define('BattleScene.SWCharacter', {
  superClass: 'BattleScene.Character',
  init: function(param, reverse){
    var self=this;
    this.superInit(param.$extend({
      width:150, height:70,
      fill:'transparent', stroke:'#000',
    }), reverse);

    this
    .on('changeLive',function(e){
      e.value?self.alpha=1.0:self.alpha=0.5;
    });
    this.iconImage = phina.display.Sprite(
        this.icon
    ).setSize(150,40).addChildTo(this).setPosition(0,-15);
    this.hpGauge = HPGauge({
      width:150, height:30,
      fill:'rgba(0,0,0,64)', stroke:'#FFF', strokeWidth:2,
      value:this.HP, maxValue:this.MHP,
      gaugeColor:'green',
    }).addChildTo(this
      .on('changeHP',function(e){this.hpGauge.setValue(e.value) }.bind(self))
    ).setPosition(0,20);
    this.spGauge = phina.ui.Gauge({
      width:100, height:5,
      fill:'#FFF', stroke:'#FFF', strokeWidth:2,
      value:this.SP, maxValue:this.MSP,
      gaugeColor: 'blue',
    }).addChildTo(this
      .on('changeSP',function(e){this.spGauge.setValue(e.value) }.bind(self))
    ).setPosition(-25,2);
    this.nameLabel = phina.display.Label({
      width:150, height:20,
      text:this.name, align:'left',
      fill:'#FFF', fontSize:20,
    }).addChildTo(this).setPosition(-75,-15);
  },
  addBuff: function(data){
    this.superMethod('addBuff', data);
  },
  removeBuff: function(data){
    this.superMethod('removeBuff', data);
  },
});
phina.define('BattleScene.LMCharacter', {
  superClass: 'BattleScene.Character',
  init: function(param, reverse){
    var self=this;
    this.superInit(param.$extend({
      width:300, height:60,
      fill:'transparent', stroke:'transparent',
    }), reverse);

    this
    .on('changeLive',function(e){
      e.value?self.alpha=1.0:self.alpha=0.5;
    });
    this.iconImage = phina.display.Sprite(
        this.icon||'noimage'
    ).setSize(60,60).addChildTo(this).setPosition(-120*reverse,0);
    if(this.iconR){
      this.iconImage.setScale(reverse,1);
    }
    this.hpGauge = HPGauge({
      width:240, height:25,
      fill:'rgba(0,0,0,64)', stroke:'#FFF', strokeWidth:2,
      value:this.HP, maxValue:this.MHP,
      gaugeColor:'green',
    }).addChildTo(this
      .on('changeHP',function(e){this.hpGauge.setValue(e.value) }.bind(self))
    ).setPosition(30*reverse,17.5);
    this.spGauge = SPGauge({
      width:100, height:5,
      fill:'#FFF', stroke:'#FFF', strokeWidth:2,
      value:this.SP, maxValue:this.MSP,
      gaugeColor: 'blue',
    }).addChildTo(this
      .on('changeSP',function(e){this.spGauge.setValue(e.value) }.bind(self))
    ).setPosition(100*reverse,2.5);
    this.nameLabel = phina.display.Label({
      width:240, height:20,
      text:this.name, align:'left',
      fill:'#FFF', fontSize:20,
    }).addChildTo(this).setPosition(-120+30*reverse,17.5);
    // this.statusType = phina.display.Sprite(
    //   this.unitType=='AT'?'img/ui/at.png':
    //       this.unitType=='DF'?'img/ui/df.png':
    //       this.unitType=='MT'?'img/ui/mt.png':
    //       this.unitType=='SD'?'img/ui/sd.png':'noimage'
    // ).addChildTo(this).setPosition(130,5);
    this.buffpocket = BattleScene.BuffPocket({
      width:240,
    }).addChildTo(this).setPosition(30*reverse,-15);
  },
  addBuff: function(data){
    this.superMethod('addBuff', data);
    this.buffpocket.addBuff(data);
  },
  removeBuff: function(data){
    this.superMethod('removeBuff', data);
    this.buffpocket.removeBuff(data);
  },
});
phina.define('BattleScene.BuffPocket', {
  superClass: 'phina.display.RectangleShape',
  init: function(param){
    param=(param||{}).$safe(BattleScene.BuffPocket.defaults);
    this.buffrid = {};
    this.superInit(param);
  },
  addBuff: function(data){
    this.buffrid[data.RID] = BuffIcon({
      width:30, height:30, frameWidth:30, frameHeight:30,
      type:data.type, color:data.color, image:'img/ui/bufficon5.png',
      name:data.name, comment:data.comment,
    }).fromJSON({RID:data.RID}).addChildTo(this)
    .setInteractive(true, 'rect')
    .on('click', ()=>{
      this.getRoot().app.pushScene(BattleScene.BuffDetail({
        buff:data,
      }));
    });
    this.reposition();
  },
  removeBuff: function(data){
    this.buffrid[data.RID].remove();
    delete this.buffrid[data.RID];
    this.reposition();
  },
  reposition: function(){
    Object.keys(this.buffrid).sort().map((v,i)=>{
      if(Math.floor(this.width/30)>i){
        this.buffrid[v].show().setPosition(
          phina.util.Grid({width:this.width,columns:Math.floor(this.width/30),offset:15}).span(i)-this.width/2,0);
      }else{
        this.buffrid[v].hide();
      }
    });
  },
  _static: {
    defaults: {
      fill: 'transparent', stroke: 'transparent',
      width:100, height:30,
    }
  }
});
phina.define('BattleScene.BuffDetail', {
  superClass: 'phina.display.DisplayScene',
  init: function(param){
    param=(param||{}).$safe(BattleScene.BuffDetail.defaults);
    this.superInit(param);
    var data = param.buff;

    var win = TempWindow({
      width:400, height:200
    }).setPosition(500,300)
    .addChildTo(this);

    BuffIcon({
      width:30, height:30, frameWidth:30, frameHeight:30,
      type:data.type, color:data.color, image:'img/ui/bufficon5.png',
      name:data.name, comment:data.comment, popup:false,
    }).fromJSON({RID:data.RID,lpadding:20}).addChildTo(win);
    phina.display.Label({
      width:100, height:30, padding:0,
      text:data.name, fontSize:24, fill:'#FFF'
    }).fromJSON({lpaddingVertical:20})
    .addChildTo(win)

    phina.display.LabelArea({
      width:360, height:120,
      text:data.comment, align:'left',
      fontSize:20, fontColor:'#FFF',
    }).addChildTo(win.br(80));

    this.on('click', ()=>{ this.app.popScene(); })

  },
  _static: {
    defaults: {
      width:1000, height:600,
      data:{},
    }    
  }
});

/**
 * 戦闘開始表示
 */
phina.define("BattleScene.BattleStart", {
    superClass: "phina.display.RectangleShape",
    init:function(){ //param
        var self=this;
        this.superInit({
            width: 1000,
            height:0,
            fill: "#222",
            stroke: "transparent",
        });
        this.fromJSON({ children: {
        p_turn: {
            className: "phina.display.Label",
            x: 0, y: 0,
            arguments: {
                align: "center", baseline: "middle",
                text: "戦 闘 開 始",
                fontSize: 40,
                fill:'#FFF',
            },
        }
        }});
        this.tweener
        .to({height:200},500,"easeInCubic")
        .wait(1000)
        .to({height:0},500,"easeOutCubic")
        .call(function(){ this.remove(); }, self);
    },
});
/**
 * NextTurn表示
 */
phina.define("BattleScene.NextTurn", {
    superClass: "phina.display.RectangleShape",
    init:function(param){
        var self=this;
        this.superInit({
            width: 1000,
            height:0,
            fill: "#222",
            stroke: "transparent",
        });
        this.fromJSON({ children: {
        p_turn: {
            className: "phina.display.Label",
            x: 0, y: 0,
            arguments: {
                align: "center", baseline: "middle",
                text: param.value+"TURN",
                fontSize: 30,
                fill:'#FFF',
            },
        }
        }});
        this.tweener
        .to({height:200},500,"easeInCubic")
        .wait(1000)
        .to({height:0},500,"easeOutCubic")
        .call(function(){ this.remove(); }, self);
    },
});
/**
 * 戦闘終了表示
 */
phina.define("BattleScene.EndGame", {
    superClass: "phina.display.RectangleShape",
    init:function(param){
        // var self=this;
        this.superInit({
            width: 200,
            height:600,
            fill: "#222",
            stroke: "transparent",
        });
        this.scene = param.scene;
        var msg = "戦闘終了";
        if(param.role=='FIRST'){
          msg = "左側チーム\n勝利";
        }else if(param.role=='SECOND'){
          msg = "右側チーム\n勝利";
        }else if(param.role=='DRAW'){
          msg = "引分";
        }
        this.fromJSON({ children: {
        p_msg: {
            className: "phina.display.Label",
            x: 0, y: 0,
            arguments: {
                align: "center", baseline: "middle",
                text: msg,
                fontSize: 30,
                fill:'#FFF',
            },
        },
        // p_restart: {
        //     className: "NormalButton",
        //     x: 0, y:150,
        //     arguments: {
        //        width:100, height:40,
        //        text: "最初から", fontSize:20,
        //        fill:'#FFF',
        //       },
        //     onpointend: self.e_restart_pointend.bind(this)
        // },
        }});
    },
    e_restart_pointend: function(){
      console.log(this.getRoot())
      this.getRoot().player
      .first().start();
        this.scene.removeChild(this);
    },
});
/**
 * 吹き出し
 */
phina.define("BattleScene.Fukidasi", {
    superClass: "phina.display.RectangleShape",
    init: function(t,w,h){
        this.superInit({
            fill: "transparent",
            stroke: "transparent",
        });
        this.checkHierarchy=true;
        var f=phina.display.Sprite(t,w,h)
            .setPosition(30,-20)
            .setSize(1,1)
            .addChildTo(this);
        f.tweener
            .by({
                x:w/2, y:-h/2,
                width:w-1, height:h-1,
            },200,"easeOutCubic")
            .wait(700)
            .to({alpha:0.0},300)
            .call(function(){ this.remove(); }.bind(this));
    },
});

/**
 * セリフ用吹き出し
 */
phina.define("BattleScene.Remark", {
  superClass: "phina.display.DisplayElement",
  init: function(options){
    options = (options||{}).$safe(BattleScene.Remark.defaults);
    this.superInit(options);
    // var self = this;
    this.canvas = phina.graphics.Canvas();
    this.width = this.calcTextWidth(options);
    this.width = this.width>options.width?options.width:this.width;
    this.text = phina.display.LabelArea({
      width:this.width, height:30, autoHeight:true,
      align:"center", fill:'#000',
      text: options.text, fontFamily: options.fontFamily,
      fontSize:options.fontSize, fontWeight:options.fontWeight,
    });
    this.back = BattleScene._Remark({
      fill:options.stroke, stroke:options.stroke,
      width:this.width+options.padding, height:this.text.height+options.padding,
      strokeWidth:options.strokeWidth, arrowRadian:options.arrowRadian,
    }).addChildTo(this).setPosition(0,0);
    this.front = BattleScene._Remark({
      fill:options.fill, stroke:'transparent', front:true,
      width:this.width+options.padding, height:this.text.height+options.padding,
      strokeWidth:options.strokeWidth, arrowRadian:options.arrowRadian,
    }).addChildTo(this).setPosition(0,0);
    this.text.addChildTo(this).setPosition(0,0);
    this.arrowRadian = options.arrowRadian;
  },
  calcTextWidth: function(options){
    var width;
    // var maxWidth = options.width;
    var context = this.canvas.context;
    context.font = "{fontWeight} {fontSize}px {fontFamily}".format(options);
    width = context.measureText(options.text).width;
    return width;
  },
  _static: {
    defaults: {
      fontSize:32,
      fontWeight:'',
      fontFamily: "'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif",
      backgroundColor: 'transparent',
      fill: 'blue',
      stroke: '#aaa',
      padding: 20,
      strokeWidth: 4,
      arrowRadian: 45,
      text: "テストだ！",
    },
  },
});
phina.define("BattleScene._Remark", {
  superClass: "phina.display.Shape",
  init: function(options){
    options = (options||{}).$safe(BattleScene._Remark.defaults);
    this.superInit(options);
    var self = this;
    this.arrow = phina.display.Shape(options).fromJSON({
      prerender: function(canvas){
        // var l = -self.width/2,
        //     r = self.width/2,
        var t = -self.height/2,
            b = self.height/2,
            rn = Math.sqrt(Math.pow(self.width/2,2)+Math.pow(self.height/2,2)),
            px = rn * Math.cos(options.arrowRadian),
            py = rn * Math.sin(options.arrowRadian);
          canvas.context.moveTo(0, t+self.height/4);
          canvas.context.lineTo(px, py);
          canvas.context.lineTo(0, b-self.height/4);
          canvas.closePath();
      }
    }).addChildTo(this).setPosition(0,0);
    this.arrowSize = options.arrowSize;
    this.zure = options.front ? 3:0;
  },
  prerender: function(canvas) {
    this.roundFukidashi(canvas, -this.width/2, -this.height/2, this.width, this.height, this.zure);
  },
  roundFukidashi: function(canvas, x, y, width, height, zure){
    var l = x,
        r = x + width,
        t = y,
        b = y + height,
        l1=l, l2=l+width/4, l3=l+width/50,
        r1=r, r2=r-width/4, r3=r-width/50,
        t1=t, t2=t+height/4, t3=t+height/6,
        b1=b, b2=b-height/4, b3=b-height/6;
    canvas.context.lineTo(l1, t2);            //左真ん中
    canvas.context.lineTo(l2, t1+zure);       //左上
    canvas.context.lineTo(r3-zure, t3);       //右上
    canvas.context.lineTo(r1, b2);            //右真ん中
    canvas.context.lineTo(r2, b1-zure);       //右下
    canvas.context.lineTo(l3+zure, b3);       //左下
    canvas.closePath();
  },
  _static: {
    defaults: {
      backgroundColor: 'transparent',
      fill: 'blue',
      stroke: '#aaa',
      strokeWidth: 4,
      arrowRadian: 45,
    },
  },
});

/**
 * カットイン
 */
phina.define("BattleScene.Cutin", {
  superClass: "phina.display.DisplayElement",
  init: function(v){
    this.superInit();
    switch(v.motion){
    case "normal":
      this.fromJSON({ children:{
      cutin: {
        className:"phina.display.Sprite",
        x:0, y:-400,
        arguments:[v.src],
        width:1000, height:300
      }
      }});
      this.cutin.tweener
      .to({y:0},250,"easeOutCubic")
      .wait(500)
      .to({y:400},250,"easeInCubic")
      .call(function(){
        this.remove();
      }.bind(this));
      break;
    }
  },
});

}
